export default {
  "root": "_root_wburs_1",
  "--multiline": "_--multiline_wburs_1",
  "input": "_input_wburs_1",
  "--rounded": "_--rounded_wburs_1",
  "affix": "_affix_wburs_1",
  "icon": "_icon_wburs_1",
  "slot": "_slot_wburs_1",
  "slot--position-end": "_slot--position-end_wburs_1",
  "affix--position-start": "_affix--position-start_wburs_1",
  "affix--position-end": "_affix--position-end_wburs_1",
  "--disabled": "_--disabled_wburs_1",
  "--size-medium": "_--size-medium_wburs_1",
  "--size-large": "_--size-large_wburs_1",
  "--size-xlarge": "_--size-xlarge_wburs_1",
  "--variant-faded": "_--variant-faded_wburs_1",
  "--variant-headless": "_--variant-headless_wburs_1",
  "--status-error": "_--status-error_wburs_1",
  "heading": "_heading_wburs_1",
  "ariaButton": "_ariaButton_wburs_1",
  "calendarCell": "_calendarCell_wburs_1",
  "inlineInput": "_inlineInput_wburs_1",
  "inputWrapper": "_inputWrapper_wburs_1",
  "calendarCellSelected": "_calendarCellSelected_wburs_1",
  "--size-medium--m": "_--size-medium--m_wburs_1",
  "--size-large--m": "_--size-large--m_wburs_1",
  "--size-xlarge--m": "_--size-xlarge--m_wburs_1",
  "--size-medium--l": "_--size-medium--l_wburs_1",
  "--size-large--l": "_--size-large--l_wburs_1",
  "--size-xlarge--l": "_--size-xlarge--l_wburs_1",
  "--size-medium--xl": "_--size-medium--xl_wburs_1",
  "--size-large--xl": "_--size-large--xl_wburs_1",
  "--size-xlarge--xl": "_--size-xlarge--xl_wburs_1"
};import "ni:sha-256;_tep5uxv8zQGaQX_t0utrGbT8Oen3VvCLtpgIJfJ5y8";